"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CART_ID_KEY = void 0;
exports.CART_ID_KEY = 'live-shopify-cart-id';
